import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { IRenter } from "../types";

type TInput = IRenter;
type TOutput = string;

export default class ChangeRenterCardApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.POST;
  allowedStatusCodes = [409];

  resolveUri(): string {
    return `/fe-api/user/renter-card`;
  }

  mapResponseData(status: number): TOutput {
    if (status === 409) {
      return "Nepodařilo se uložit změny v dotazníku pronajímatele. Naše chyba. Prosím zkuste to znovu, nebo nás kontaktujte.";
    }

    return "ok";
  }

  mapRequestData(input: TInput): any {
    return {
      first_name: input.firstName ? input.firstName.trim() : "",
      last_name: input.lastName ? input.lastName.trim() : "",
      occupation: input.occupation ? input.occupation.trim() : "",
      birth: input.birth,
      boarding: input.rentStartAt,
      children: input.childrenId !== "-1" ? input.childrenId : null,
      expected_accomodation_length_id: input.accommodationDurationId || null,
      roommates: input.roommatesId,
      animal_id: input.animalId,
      informations: input.informations ? input.informations.trim() : "",
      phone: input.phone?.number ? input.phone.prefix + input.phone.number : "",
    };
  }
}
